// © Copyright 2026 Emman Consulting SAS
import React, { useState, useEffect, useRef } from "react";
import { I18N } from "../../i18n.js";

export default function Header({ user, sync, lang, onLang, onLogout }) {
  const [drop, setDrop] = useState(false);
  const ref = useRef(null);
  const t = I18N[lang];

  useEffect(() => {
    const h = (e) => { if (!ref.current?.contains(e.target)) setDrop(false); };
    document.addEventListener("click", h);
    return () => document.removeEventListener("click", h);
  }, []);

  return (
    <header className="hdr">
      <div className="hdri">
        <div className="hbrand">
          <div className="hname">FIGURIX · US MX CA 26</div>
        </div>
        <div className="hright">
          <div className="hlang" onClick={onLang}>
            <span className={"hlang-opt" + (lang === "es" ? " on" : "")}>ES</span>
            <span className="hlang-sep">·</span>
            <span className={"hlang-opt" + (lang === "en" ? " on" : "")}>EN</span>
          </div>
          <div className="umenu" ref={ref}>
            <div className="uavatar" onClick={() => setDrop((d) => !d)}>
              {(user?.email || "U").charAt(0).toUpperCase()}
            </div>
            {drop && (
              <div className="udrop">
                <div className="udrop-email">{user?.email}</div>
                <button className="udrop-btn" onClick={onLogout}>{t.logout}</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
